module.exports = __webpack_public_path__ + "static/media/bonnie-lose.08cd9671.png";